// Copyright 2025. WebPros International GmbH. All rights reserved.

export const OS_IMAGE_VERSION = {
    DELETE: 'os-image-version-delete',
    VISIBILITY: 'os-image-version-visibility',
};
